// extracted by mini-css-extract-plugin
module.exports = {"container":"NotiCard_container__Uh0nl","header":"NotiCard_header__1ATDQ","headtxt":"NotiCard_headtxt__36jrp","box":"NotiCard_box__ECFv3","det":"NotiCard_det__1OOKh"};